import React, {FC, useMemo} from 'react';

import {HandlerOf} from '../../../../libs/shared/helpers/src/react/reactHelpers';
import {Icon} from '../../../../libs/shared/ui/src/components/icon/icon';
import {useUserTheme} from '../../../../libs/shared/ui/src/theme/userThemeProvider';
import {AtomGroupTitle} from '../../editors/expressions/atomGroupTitle';
import {AtomItem, AtomItemGroups} from '../../editors/expressions/expressionAtomHelpers';
import {getExpressionTypeDropdownIcon} from '../../editors/expressions/expressionIcons';
import {MultipleGroupsDropdownBox} from './dropdowns/multipleGroupsDropdownBox';
import {DropdownGroup} from './dropdowns/multipleGroupsDropdownHelpers';

/*
 * Types.
 */

interface RuleExpressionsAtomPickerProps {
  groups: AtomItemGroups;
  onAddAtom: HandlerOf<AtomItem>;
}

/*
 * Component.
 */

export const RuleExpressionsAtomPicker: FC<RuleExpressionsAtomPickerProps> = (props) => {
  const theme = useUserTheme();
  const {groups, children, onAddAtom} = props;

  const atomGroups = useMemo(
    () =>
      groups.map((group) => {
        const dropdownGroup: DropdownGroup<AtomItem> = {
          title: <AtomGroupTitle id={group.id} />,
          items: group.items,
          serializeItemForSearch: (item) => item.name,
          renderItemLabel: (item) => item.name,
          renderItemTooltip: (item) => item.tooltip,
          renderItemIcon: (item) => (
            <Icon name={getExpressionTypeDropdownIcon(item.atom.inferredType)} color={theme.greys.shade70} />
          ),
          getItemKey: (item) => item.id,
        };
        return dropdownGroup;
      }),
    [groups],
  );

  return (
    <MultipleGroupsDropdownBox
      groups={atomGroups}
      selectedItems={[]}
      canSelectMultipleItems={false}
      onChange={(selectedValue: ReadonlyArray<AtomItem>) => onAddAtom(selectedValue[0])}
      renderButton={() => children}
      width={300}
      hasBackground
    />
  );
};
